import { ReactNode } from 'react'
import classnames from 'classnames'

type Props = {
  children?: ReactNode
  value: string
  //classes: string
  isLast: boolean
  isClueThatWon?: boolean
  isGameWon?: boolean
}

export const Hint = ({
  children,
  value,
  //classes,
  isLast,
  isClueThatWon=false,
  isGameWon=false
}: Props) => {
  var indent = ""
  if (value !== undefined && value !== "" ){ indent = "»" } //• ⚫ ⚪ »

  const classes = classnames(
    'text-m leading-4 font-medium flex flex-col mt-1 divide-y',
    {
      'text-gray-900 dark:text-gray-100':  (!isClueThatWon && !isLast) || (isLast && isGameWon && !isClueThatWon),
      'text-yellow-500': isLast && !isGameWon,
      'text-green-500': isClueThatWon,
    })

  return (
    <div className="flex mb-1 scroll-text">
      <p className={classes}>
        {indent} {children || value}
      </p>
    </div>
  )
}
